import { createAction, props } from '@ngrx/store'
import { Experience } from './experience.state'

// Action to load Department
export const loadExperiences = createAction(
  '[Experience] Load Experience',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Experience load
export const loadExperiencesSuccess = createAction(
  '[Experience] Load Experience Success',
  props<{
    experiences: Experience[]
    totalExperienceYears: number
  }>()
)

// Action for Department load failure
export const loadExperiencesFailure = createAction(
  '[Experience] Load Experience Failure',
  props<{ error: string }>()
)

export const createExperience = createAction(
  '[Experience] Create Experience',
  props<{
    payload: any
  }>()
)

export const createExperienceSuccess = createAction(
  '[Experience] Create Experience Success',
  props<{ experience: Experience }>()
)

export const createExperienceFailure = createAction(
  '[Experience] Create Experience Failure',
  props<{ error: any }>()
)

export const updateExperience = createAction(
  '[Experience] Update Experience',
  props<{ id: string; payload: any }>()
)

export const updateExperienceSuccess = createAction(
  '[Experience] Update Experience Success',
  props<{ experience: Experience }>()
)

export const updateExperienceFailure = createAction(
  '[Experience] Update Experience Failure',
  props<{ error: any }>()
)

export const deleteExperience = createAction(
  '[Experience] Delete Experience',
  props<{ id: string }>()
)

export const deleteExperienceSuccess = createAction(
  '[Experience] Delete Experience Success',
  props<{ id: string }>()
)

export const deleteExperienceFailure = createAction(
  '[Experience] Delete Experience Failure',
  props<{ error: any }>()
)
